import React, { createContext, useContext, useEffect, useState } from 'react';

type TenantContextType = {
  activeTenantCode: string | null;
  activeTenantName: string | null;
  setActiveTenant: (code: string, name: string) => void;
  actionBreadcrumbName: string | null;
  setActionBreadcrumbName: (name: string | null) => void;
};

const TenantContext = createContext<TenantContextType | undefined>(undefined);

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeTenantCode, setActiveTenantCode] = useState<string | null>(null);
  const [activeTenantName, setActiveTenantName] = useState<string | null>(null);
  const [actionBreadcrumbName, setActionBreadcrumbName] = useState<string | null>(null);

  useEffect(() => {
    const storedCode = localStorage.getItem('activeTenantCode');
    const storedName = localStorage.getItem('activeTenantName');

    if (storedCode) setActiveTenantCode(storedCode);
    if (storedName) setActiveTenantName(storedName);
  }, []);

  const setActiveTenant = (code: string, name: string) => {
    localStorage.setItem('activeTenantCode', code);
    localStorage.setItem('activeTenantName', name);

    setActiveTenantCode(code);
    setActiveTenantName(name);
  };

  return (
    <TenantContext.Provider
      value={{
        activeTenantCode,
        activeTenantName,
        setActiveTenant,
        actionBreadcrumbName,
        setActionBreadcrumbName,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant must be used inside TenantProvider');
  return ctx;
};
